import { type SortByKeys, SORT_BY_KEYS, SORT_BY_OPTIONS } from '@/constants/search'
import { type SortOption } from '@/generated'

/** Turn the selected sort option from SearchResultsPage data into the matching sortOptionKey used in url */
export const mapSelectedSortOptionToSortKey = (selectedSortOption?: SortOption): SortByKeys => {
  if (!selectedSortOption) return SORT_BY_KEYS.DATE_DESC

  const { by: selectedSortBy, direction: selectedSortDirection } = selectedSortOption

  const selectedSortKey: SortByKeys | undefined = (
    Object.keys(SORT_BY_OPTIONS) as SortByKeys[]
  ).find((sortOptionKey) => {
    const { sort, order } = SORT_BY_OPTIONS[sortOptionKey]
    return sort === selectedSortBy && order === selectedSortDirection
  })

  return selectedSortKey || SORT_BY_KEYS.DATE_DESC
}
